<script context="module">
	import { z } from "zod";
	export const name = "Blogs";
	export const CustomFields = z.object({
		show_summary: z.boolean().optional(),
		show_role: z.boolean().optional(),
	});
</script>

<script>
	import { getContext } from "svelte";
	import { initials, avatarUrl, authorRole } from "../../includes/content.js";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	const context = getContext("context");

	$: content = data && data.content;
	$: cf = (data && data.custom_fields) || {};
	$: showSummary = cf.show_summary === true;
	$: showRole = cf.show_role !== false;
	$: author = content && content.authors && content.authors[0]?.name ? content.authors[0] : null;
	$: avatar = avatarUrl(author, 144);
	$: role = showRole && author ? authorRole(author, ($context && $context.domain) || (content && content.domain)) : null;
</script>

{#if content}
	<article class="af-card af-item af-item--blog">
		<div class="af-card__body">
			{#if author}
				<div class="af-byline">
					<a class="af-author-link" href={author.id != null ? `/author/${author.id}` : undefined} rel="author">
					<span class="af-avatar" aria-hidden="true">
						{#if avatar}
							<img src={avatar} alt="" width="72" height="72" loading="lazy" />
						{:else}
							{initials(author.name)}
						{/if}
					</span>
					<span class="af-byline__name">{author.name}</span>
					</a>
					{#if role}<span class="af-byline__role">{role}</span>{/if}
				</div>
			{/if}
			<h3 class="af-card__title"><a href={content.url}>{content.title}</a></h3>
			{#if showSummary && content.summary}
				<p class="af-card__summary">{content.summary}</p>
			{/if}
		</div>
	</article>
{/if}

<style lang="scss">
	@use "../../styles/mixins" as m;

	.af-card {
		@include m.af-card;
	}

	.af-card__body {
		display: flex;
		flex-direction: column;
		gap: var(--af-space-3);
		padding: var(--af-space-6);
		border-top: 2px solid var(--af-accent);
		overflow-wrap: anywhere;
		flex: 1 1 auto;
	}

	.af-card__title {
		font: 600 var(--af-text-h3) / var(--af-leading-tight) var(--af-font-serif);
		color: var(--af-ink);
		text-wrap: balance;

		a {
			@include m.af-clamp(4);

		}
	}

	.af-byline {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: var(--af-space-2);
	}

	.af-author-link {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: var(--af-space-3);
	}

	a {
		border-radius: 2px;
		&:focus-visible { outline: 2px solid var(--af-focus); outline-offset: 3px; }
		&:hover { color: var(--af-accent); }
	}

	.af-avatar {
		flex: 0 0 auto;
		width: 72px;
		height: 72px;
		border-radius: 50%;
		overflow: hidden;
		display: grid;
		place-items: center;
		background: var(--af-surface-sunk);
		color: var(--af-ink-muted);
		font: 600 24px / 1 var(--af-font-serif);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.af-byline__name {
		font: 600 var(--af-text-ui) / 1.3 var(--af-font-sans);
		color: var(--af-ink);
	}

	.af-byline__role {
		font-size: var(--af-text-meta);
		color: var(--af-ink-muted);
	}

	.af-card__summary {
		font-size: var(--af-text-body-sm);
		line-height: 1.5;
		color: var(--af-ink-muted);
		@include m.af-clamp(3);
	}
</style>
